import json from '@/_results.json'

// state
const state = {

    subdir: process.env.VUE_APP_SUBDIR ? process.env.VUE_APP_SUBDIR : '',
    preloadPage: true,
    showMenuInLanding: false,
    bgImage: '',
    flyPreviewActive: true,
    environmentsOrigin: json.environments,
    environments: json.environments,
    solutions: json.solutions,
    strategic: json.strategic,
    activeEnvSlug: 'reception',
    activeEnvData: {},
    activeEnvSlugs: [],
    envSlugs: [
        {
            idx: 0,
            slug: "reception",
            id: "reception",
            file: "_1_reception",
        },
        {
            idx: 1,
            slug: "office-desk",
            id: "officeDesk",
            file: "_2_office-desk",
        },
        {
            idx: 2,
            slug: "shared-area",
            id: "sharedArea",
            file: "_3_shared-area",
        },
        {
            idx: 3,
            slug: "tech-bar",
            id: "techBar",
            file: "_4_tech-bar",
        },
        {
            idx: 4,
            slug: "collaberation",
            id: "collaberation",
            file: "_5_collaberation",
        },
        // {
        //     slug: "tech-bar-meeting-room",
        //     img: "tech.jpg",
        //     videoIn: "tttttt.mp4",
        //     videoNext: "tttttt.mp4",
        // },
    ],
    goFrom: null,
}

// getters
const getters = {
    // global data
    preloadPage: state => state.preloadPage,
    subdir: state => state.subdir,
    bgImage: state => state.bgImage,
    // environments: state => state.environmentsOrigin,
    environments: (state) => {
        let env = [];
        state.environmentsOrigin.forEach((item) => {
            console.log(item)
            let el = {
                ...item
            };
            el.image = state.subdir + item.image
            env.push(el);
        })
        return env;//state.environmentsOrigin;
    },
    solutions: state => state.solutions,
    strategic: state => state.strategic,

    flyPreviewActive: state => state.flyPreviewActive,

    activeEnvSlug: state => state.activeEnvSlug,
    envSlugs: state => state.envSlugs,
    activeEnvSlugs: (state) => {
        let slugs = [];
        slugs = state.environments.map((item) => {
            return item.slug;
        })
        return slugs;
    },

    goFrom: state => state.goFrom,
    showMenuInLanding: state => state.showMenuInLanding,
}

// mutations
const mutations = {
    SET_ACTIVE_ENVIRONMENT_SLUG(state, slug) {
        state.activeEnvSlug = slug
    },
    SET_FLY_PREVIEW_ACTIVE(state, status) {
        state.flyPreviewActive = status
    },
    SET_GO_FROM(state, status) {
        state.goFrom = status
    },
    SET_BG_IMAGE(state, bgImage) {
        state.bgImage = bgImage;
    },
    SET_FRONTPAGE(state, status) {
        state.preloadPage = status;
    },
    SET_SHOWMENU_IN_LANDING(state, status) {
        state.showMenuInLanding = status;
    },
}

// actions
const actions = {
    setActiveEnvSlug({commit}, slug) {
        commit('SET_ACTIVE_ENVIRONMENT_SLUG', slug)
    },
    setFlyPreviewActive({commit}, status) {
        commit('SET_FLY_PREVIEW_ACTIVE', status)
    },
    setGoFrom({commit}, slug) {
        if (slug === null) {
            commit('SET_GO_FROM', null)
        } else {
            let el = state.envSlugs.find((item) => {
                return item.slug == slug
            })
            commit('SET_GO_FROM', el.idx)
        }

    },
    setBgImage({commit}, bgImage) {
        console.log(bgImage);
        if (bgImage) {
            commit('SET_BG_IMAGE', bgImage)
        }

    },
    setFrontPagePreload({commit}, status) {
        commit('SET_FRONTPAGE', status)
    },
    setShowMenuInLanding({commit}, status) {
        commit('SET_SHOWMENU_IN_LANDING', status)
    },
    // setEnvironments(state) {
    //     state.environments = json.environments
    // },
    // setSolutions(state) {
    //     state.setSolutions = json.solutions
    // },
    // setStrategic(state) {
    //     state.strategic = json.strategic
    // },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}